import React, { useState } from "react";
import { submitForm } from "../../lib/api.js";
import { Section } from "./Page.js";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const go = async (e) => {
    e.preventDefault();
    const r = await submitForm("newsletter", { email });
    setMsg(r.ok ? "Thanks for subscribing." : r.error);
  };
  return (
    <Section title="Climate market updates, monthly">
      <form className="pg-news" onSubmit={go}>
        <input type="email" required placeholder="you@company.com" aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button className="pg-btn" type="submit">Subscribe</button>
      </form>
      {msg && <p className="pg-msg">{msg}</p>}
    </Section>
  );
}
